export default __webpack_public_path__ + "static/media/whatsApp.f907d209.svg";